module.exports = __webpack_public_path__ + "static/media/hc50.d9dde83c.mp3";